import * as React from 'react';

import {
  enumCurrencyCode,
  enumUnit,
  MoneyInput,
  Unit,
  Weight,
} from '@rematter/frontend-lib-api-client';

import {
  calculateTotalEachCount,
  calculateTotalNetWeight,
  getCommonPricingUnit,
  LineItemForTotals,
} from '~/modules/trade/utils/weight';

type QuoteLineItemForTotals = {
  quantity: number;
  unit: string;
  totalPrice: MoneyInput;
};

type QuoteLineItemsTotals = {
  totalWeight: Weight | null;
  totalEachCount: number;
  displayUnit: Unit;
  estimatedTotal: MoneyInput;
};

export const useQuoteLineItemsTotals = (
  lineItems: QuoteLineItemForTotals[],
): QuoteLineItemsTotals =>
  React.useMemo(() => {
    const items: LineItemForTotals[] = lineItems.map((li) => ({
      quantity: li.quantity,
      unit: li.unit as Unit,
    }));

    const displayUnit = getCommonPricingUnit(items, enumUnit.Pounds);
    const totalWeight = calculateTotalNetWeight(items, displayUnit);
    const totalEachCount = calculateTotalEachCount(items);

    const estimatedTotalAmount = lineItems.reduce(
      (sum, li) => sum + (li.totalPrice?.amount ?? 0),
      0,
    );

    const currencyCode =
      lineItems.find((li) => li.totalPrice?.currencyCode)?.totalPrice
        ?.currencyCode ?? enumCurrencyCode.USD;

    return {
      totalWeight,
      totalEachCount,
      displayUnit,
      estimatedTotal: { amount: estimatedTotalAmount, currencyCode },
    };
  }, [lineItems]);
